

<template>
  <div class="mt-10 sm:mt-8 mx-5 sm:mx-10">
    <!-- About me counters -->
    <div
      class="font-general-regular container-fluid block sm:flex sm:justify-between sm:items-center"
    >
      <!-- Years of experience counter -->
      <div class="mb-20 sm:mb-0">
        <counter
          ref="counter"
          :startAmount="0"
          :endAmount="2"
          :duration="1"
          :autoinit="true"
          suffix="+"
          @finished="alert(`Counting finished!`)"
          class="font-general-medium text-[3rem] font-bold text-secondary-dark dark:text-secondary-light mb-2"
          aria-label="About Status Counter"
        />
        <span class="block text-lg text-ternary-dark dark:text-ternary-light">{{ experienceTitle }}</span>
      </div>

      <!-- GitHub stars counter -->
      <!-- <div class="mb-20 sm:mb-0">
				<counter
					ref="counter"
					:startAmount="0"
					:endAmount="20"
					:duration="1"
					suffix="k+"
					:autoinit="true"
					@finished="alert(`Counting finished!`)"
					class="font-general-medium text-4xl font-bold text-secondary-dark dark:text-secondary-light mb-2"
				/>
				<span
					class="block text-md text-ternary-dark dark:text-ternary-light"
					>{{ githubTitle }}</span
				>
      </div>-->

      <!-- Positive feedback counter -->
      <div class="mb-20 sm:mb-0">
        <counter
          ref="counter"
          :startAmount="0"
          :endAmount="5"
          :duration="1"
          suffix="+"
          :autoinit="true"
          @finished="alert(`Counting finished!`)"
          class="font-general-medium text-[3rem] font-bold text-secondary-dark dark:text-secondary-light mb-2"
        />
        <span class="block text-md text-ternary-dark dark:text-ternary-light">{{ feedbackTitle }}</span>
      </div>

      <!-- Projects completed counter -->
      <div class="mb-20 sm:mb-0">
        <counter
          ref="counter"
          :startAmount="0"
          :endAmount="8"
          :duration="1"
          :autoinit="true"
          suffix="+"
          @finished="alert(`Counting finished!`)"
          class="font-general-medium text-[3rem] font-bold text-secondary-dark dark:text-secondary-light mb-2"
        />
        <span class="block text-md text-ternary-dark dark:text-ternary-light">{{ projectsTitle }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import counter from "vue3-autocounter";
export default {
  components: {
    counter
  },
  data: () => {
    return {
      experienceTitle: "Years of experience",
      githubTitle: "Stars on GitHub",
      feedbackTitle: "Happy Clients",
      projectsTitle: "Projects completed"
    };
  }
};
</script>
